import { useEffect, useRef } from 'react';
import bem from '../../../utils/bem';
// import ListingMeta from '../../Organisms/ListingMeta/ListingMeta';
import Pager from '../../Molecules/Pager';
import scrollTo from '../../../utils/scrollTo';
import useWindowWidth from '../../../hooks/useWindowWidth';
// import getPagedResults from '../../../utils/getPagedResults';
import JobsListingHeader from '../../Organisms/JobsListingHeader';

let isInitialized = false;

const ListingTemplateJobs = ({
  listingHeader = true,
  showSelectedSort,
  pagerData,
  enableAutoScroll = true,
  mods,
  extra = [],
  children,
  queryState,
  setQueryState,
  filtersConfig,
  filtersState,
  setFiltersState,
  queryPlaceHolder,
  clearAllCallback,
}) => {
  const baseClass = 'sgna-job-listing';
  const topFilters = filtersConfig || {};
  const listRef = useRef(null);
  const { width } = useWindowWidth();

  useEffect(() => {
    if (isInitialized && enableAutoScroll && !window.isStoryBook) {
      const bodyPadding =
        parseInt(document.querySelector('body').style.paddingTop, 10) || 0;
      const header = document.querySelector('.header');
      const headerHeight =
        !header || width < 960 ? 0 : parseInt(header.offsetHeight, 10);
      scrollTo(100, listRef.current.offsetTop - bodyPadding - headerHeight);
    } else if (typeof pagerData.meta.pageNumber !== 'undefined') {
      isInitialized = true;
    }
  }, [pagerData.meta.pageNumber]);

  return (
    <div className={bem(baseClass, mods, '', extra)} ref={listRef}>
      {listingHeader && (
        <JobsListingHeader
          formConfig={topFilters}
          queryState={queryState}
          setQueryState={setQueryState}
          filtersConfig={filtersConfig}
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          queryPlaceHolder={queryPlaceHolder}
          clearAllCallback={clearAllCallback}
        />
      )}
      <div className={bem('listing', ['jobs'])}>
        {children}
        {showSelectedSort}
      </div>
      {<Pager {...pagerData} />}
    </div>
  );
};

export default ListingTemplateJobs;
